<template>
  <div class="popup" @click="click_close_popup">
    <div class="form_popup_container popup_content_container">
      <div class="contact-form">
        <div
          class="w-full max-w-3xl mx-auto text-left bg-white shadow-md rounded px-10 pt-16 pb-6 mb-3 relative"
          @click="prevent_close($event)"
        >
          <div class="option-bar">
            <span href="#" class="close-link" @click="close_popup">X</span>
          </div>

          <div class="option-bar2">
            <a href="#" class="back-link" @click.prevent="goBack">Back</a>
          </div>
          <div>
            <h1 class="text-red-500 uppercase font-bold mb-8 text-center">
              Welcome to the Caricature Zone!
            </h1>
            <div class="" v-if="form_status == 0 || form_status == 1">
              <div v-if="form_status == 0">
                <p>
                  Upload one of your favorite photos below to receive a custom
                  caricature.
                </p>
                <p class="mt-2">
                  Our amazing artists are standing by ready to draw! Please
                  limit to one photo submission.
                </p>

                <form
                  class="bg-white mb-2 mt-2 sm:mb-4"
                  ref="entrance_form"
                  enctype="multipart/form-data"
                  @submit.prevent="do_submit"
                >
                  <br />
                  <div class="md:grid md:grid-cols-2 md:gap-3">
                    <template v-for="item in form_model">
                      <SimpleTextField
                        :id="item.id"
                        :label="item.label"
                        v-model="item.value"
                        :extra_field_class="item.extra_class"
                        :type="item.type"
                        v-if="item.type == 'text'"
                        :key="item.id"
                        :required="item.required"
                      />
                      <HiddenField
                        :id="item.id"
                        v-model="item.value"
                        v-if="item.type == 'hidden'"
                        :key="item.id"
                      />
                    </template>
                  </div>

                  <div class="pt-2">
                    <div :class="field_container_class">
                      <label
                        class="block text-gray-700 text-sm font-bold mb-0 sm:mb-2"
                        for="name"
                      >
                        <span :class="extra_file_class"
                          >Select a photo to upload*</span
                        >
                      </label>
                      <file-pond
                        ref="pond"
                        label-idle="Select a photo"
                        max-files="1"
                        allow-multiple="false"
                        instant-upload="false"
                        v-on:updatefiles="handleFilePondUpdateFile"
                        :class="extra_file_class"
                        acceptedFileTypes="image/png, image/jpeg"
                        maxFileSize="8MB"
                      />
                    </div>
                  </div>
                  <div class="text-gray-600 text-md pt-2 pb-6 px-2">
                    Check your inbox next week to receive your caricature!
                  </div>
                  <div class="text-xs py-4 text-center">
                    By submitting this request, I hereby grant to CVS Health and
                    its respective parents, subsidiaries, affiliates, successors
                    and assigns, and to such other persons or entities that may
                    be designated from time to time (collectively, “CVS
                    Health”), the absolute right and permission to use or
                    license the use in perpetuity my name, portrait, likeness,
                    voice, image and photograph of me either alone or
                    accompanied by other material, in any manner and in any
                    media, throughout the world for the purpose of promotion of
                    CVS Health and its programs. I agree that any pictures or
                    photographs taken of me by the CVS Health are owned by CVS
                    Health. If I should receive any print, negative or other
                    copy thereof, I shall not authorize its use by anyone else.
                    I hereby waive all my rights to inspect and approve the
                    finished product. Nothing herein will constitute any
                    obligation on the CVS Health to make any use of any of the
                    rights set forth herein.
                  </div>
                  <div
                    class="flex items-center justify-around flex-col sm:flex-row flex-grow"
                  >
                    <button
                      class="bg-default-btn-color hover:bg-default-btn-color-hover text-white font-bold py-3 sm:py-2 px-10 rounded focus:outline-none focus:shadow-outline w-full my-1"
                      type="button"
                      @click="do_submit()"
                    >
                      SUBMIT
                    </button>
                  </div>
                </form>
              </div>
              <div v-else>
                <div class="w-full max-w-lg mx-auto text-center pt-2 pb-12">
                  <img src="../../assets/loading.svg" class="mx-auto" />
                  SENDING, PLEASE WAIT
                </div>
              </div>
            </div>
            <div v-if="form_status == 2" class="text-center px-3 py-8">
              Thank you for submitting your photo we are excited to draw,
              <br />please watch your email!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactFormPage from "../deprecated/ContactFormPage";

import { FileStatus } from "filepond";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";

const VueFilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize
);

import SimpleTextField from "./../form/SimpleTextField";
import HiddenField from "./../form/HiddenField";
import { mapState, mapGetters } from "vuex";

export default {
  name: "CaricatureUploadPopup",
  components: {
    VueFilePond,
    SimpleTextField,
    HiddenField
  },
  data() {
    return {
      form_status: 0,
      file: [],
      form_model: [
        {
          id: "name",
          type: "text",
          required: true,
          label: "First Name",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "last_name",
          type: "text",
          required: true,
          label: "Last Name",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "email",
          type: "text",
          required: true,
          label: "Email",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "event_tag",
          type: "hidden",
          required: false,
          label: "Event Tag",
          value: "",
          extra_class: "",
          validation: []
        }
      ],
      common_field_class:
        "shadow appearance-none border rounded w-full py-1 sm:py-2 px-0 xm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white",
      extra_file_class: "",
      field_container_class: "mb-2 sm:mb-4 md:mb-6 text-left"
    };
  },
  computed: {
    ...mapState([
      "site_config",
      "booth_form",
      "current_section",
      "sections_content"
    ]),
    ...mapGetters(["sectionContent", "eventTag", "getSection"]),
    page_url() {
      var str = "/" + this.eventTag;
      if (this.$store.state.app_type == "mobile") {
        str += "/mobile";
      }
      str +=
        "/popups/" +
        this.selected_section_name
          .split(" ")
          .join("-")
          .split("<br>")
          .join("-")
          .split("/")
          .join("-")
          .toLowerCase() +
        "/form/";
      return str;
    },
    is_closable() {
      return (
        this.$store.state.can_skip_videos || this.$store.state.app_state == 2
      );
    },
    name_field_class() {
      var str = this.common_field_class;
      str += this.extra_name_field_class;
      return str;
    },
    selected_section_name() {
      if (this.current_section === 0) {
        return "home";
      }
      return this.getSection(this.current_section).name;
    }
  },
  methods: {
    do_submit(app_mode) {
      let formData = new FormData();

      let valid_form = true;

      this.form_model.forEach((item) => {
        let valid_field = true;
        let validation = item.validation;

        validation.forEach((validation_type) => {
          switch (validation_type) {
            case "notempty":
              if (item.value.length <= 0) {
                valid_form = false;
                valid_field = false;
              }

              break;
          }
        });
        if (valid_field) {
          item.extra_class = "";
        } else {
          item.extra_class = " border-red-500 ";
        }
      });

      if (this.file.length <= 0) {
        this.extra_file_class = "text-red-400";
        valid_form = false;
      } else {
        this.extra_file_class = "";
      }

      let file = this.file[0];

      //for debugging purposes, allow the form to always be valid
      //so we don't need to fill it in all the time
      if (!this.site_config.validate_form) {
        valid_form = true;
      }

      if (!valid_form) {
        return;
      }

      var data_to_submit = new FormData();
      data_to_submit.append("file", file);

      this.form_model.forEach((item) => {
        data_to_submit.append(item.id, item.value);
      });

      this.form_status = 1;

      this.$store
        .dispatch("submit_photo_data", data_to_submit)
        .then((response) => {
          console.log("Success");
          this.form_status = 2;
          this.form_model.forEach((item) => {
            item.value = "";
          });
        })
        .catch((error) => {
          console.log("Error", error);
          this.form_status = 0;
        });

      this.$refs.entrance_form.reset();

      this.$ga.event(this.eventTag + "-form", "submit", this.page_url, 1);
    },
    click_close_popup(e) {
      if (this.is_closable) {
        e.preventDefault();
        this.close_popup(e);
      }
    },
    handleFilePondUpdateFile(files) {
      let file_array = [];
      files.forEach((item) => {
        if (item.status == FileStatus.IDLE) {
          file_array.push(item.file);
        }
      });
      this.file = file_array;
    },
    close_popup(e) {
      console.log("close popup");
      //if(e)
      //e.preventDefault();

      //there's a difference between the number of the transition
      //and what unity's animator is expecting for its param.
      //so unity is always one number ahead
      //quick fix is to send transition number minus one, but let's do better next time
      if (this.$store.state.app_state == 0) {
        this.$bus.$emit(
          "send_unity_msg",
          "JsRequestTransition",
          parseInt(this.$store.state.popup_video_src, 10)
        );
      }
      this.$store.dispatch("set_popup_state", "");

      this.loading = "loading";
      //this.$bus.$emit('send_unity_msg', 'OnVideoPopupClose', null)
    },
    prevent_close(e) {
      e.stopPropagation();
    },

    goBack() {
      this.close_popup(null);

      setTimeout(
        function () {
          this.$store.dispatch("set_current_section", "5");
          this.$store.dispatch(
            "set_popup_state",
            this.sections_content["5"].type
          );
        }.bind(this),
        600
      );
    }
  },
  mounted() {
    console.log("mounted form " + this.page_url);
    this.$bus.$emit("send_unity_msg", "JsOnPopupStateChanged", 1);

    this.form_model.forEach((item) => {
      switch (item.id) {
        case "event_tag":
          item.value = this.eventTag;
          break;
        case "name":
          item.value = this.booth_form.name || "";
          break;
        case "last_name":
          item.value = this.booth_form.last_name || "";
          break;
        case "email":
          item.value = this.booth_form.email || "";
          break;
      }
    });
    this.$ga.page(this.page_url);
  },
  beforeDestroy() {
    console.log("removed form");
    this.$bus.$emit("send_unity_msg", "JsOnPopupStateChanged", 0);
  }
};
</script>
<style>
@import "./../../../node_modules/filepond/dist/filepond.min.css";
</style>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  width: 100%;
  bottom: 0;
  display: flex;
  flex-flow: column;
  xjustify-content: space-around;
}
.popup_content_container {
  margin-top: auto;
  margin-bottom: auto;
  max-height: calc(var(--vh, 1vh) * 100);
  overflow: auto;
}
.option-bar {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
}
.close-link {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 40px;
  height: 40px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
}

.loading-app {
  text-align: center;
  color: #999;
}
.loading-app img {
  display: block;
  width: 150px;
  height: 150px;
  min-width: 150px;
  min-height: 150px;
  margin: 0 auto;
}
.option-bar2 {
  position: absolute;
  top: 10px;
  left: 10px;
  height: 35px;
  text-transform: uppercase;
}
.option-bar2 a {
  background: url("../../assets/icon-back-black.png") 0 center no-repeat;
  padding-left: 20px;
  color: #404040;
  display: inline-block;
  height: 35px;
  color: #101010;
  line-height: 35px;
  font-size: 0.9rem;
}
</style>
<style>
.filepond--wrapper.text-red-400 .filepond--drop-label label {
  color: #ff1100 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/CaricatureUploadPopup.vue